<h2>{{'elite_ranking' | transloco}}: &nbsp; <span>
  {{
  (
  filter_service.categoriesCombo.comboData
  | async
  )?.name
  }}
  {{
  (
  filter_service.yearCombo.comboData
  | async
  )?.Year
  }}
</span></h2>
<app-wa-table [showNoResultsMessageCondition]="ShowNoResultsBox" [showNoResultsMessage]="customLoadMsg"
 [isSortableFunc]="sortClass" [showCondition]="true"
 [headers]="headers"
 [isDataLoading]="loading && (filter_service.categoriesCombo.comboData|async) != undefined"
[areMoreData]="areMoreData() && (filter_service.categoriesCombo.comboData|async) "
(loadMore)="loadMore()"
 [data]="data"
 (headerClick)="changeSort($event)">
<ng-template  app-column let-ranking>
  <div style="display: flex; justify-content: center; flex-direction: column;">

  <div class="border-ranking-box" >{{ ranking.Rnk }}</div>


  <div style="height: 10px;" *ngIf="ranking.Rnk === ranking.RnkOld;else variation" class="icon--equal"></div>
  <ng-template #variation>
    <div *ngIf="ranking.RnkOld && (ranking.Rnk < ranking.RnkOld)" class="icon--up">
      {{ {rank:ranking.Rnk, rankOld: ranking.RnkOld} | parseRank}}
      </div>
    <div *ngIf="ranking.RnkOld && (ranking.Rnk > ranking.RnkOld)" class="icon--down">
      {{ {rank:ranking.Rnk, rankOld: ranking.RnkOld} | parseRank}}
    </div>
    <ng-container *ngIf="ranking.Rnk && ranking.RnkOld == null">
      <div style="text-align: center; font-size: 12px;" class="list-row-item__ranking__arrow new new__margin">
        {{'NEW' | transloco}}
      </div>
    </ng-container>

  </ng-template>
</div>
</ng-template>
<ng-template  app-column let-ranking>
<lib-athlete-name [fname]="ranking.Athlete.FName" [gname]="ranking.Athlete.GName" [wnameord]="ranking.Athlete.WNameOrd" [id]="ranking.Athlete.Id"></lib-athlete-name>
</ng-template>
<ng-template  app-column let-ranking>
<div class="uppertext-no-viewport" *ngIf="ranking.Team && ranking.Team.TeamName;else noTeam">{{ranking.Team.TeamName}} </div>
<ng-template #noTeam>
  <div>&nbsp;</div>
</ng-template>
</ng-template>
<ng-template  app-column let-ranking>
<div class="uppertext-no-viewport">{{ranking.Points}} </div>

</ng-template>
<ng-template app-column let-ranking>
<div class="list-row-item__action" *ngIf="{data:data, showDetails:false} as detail" (click)="selectIndex(ranking.index)">
  <span class="plus-minus {{isIndexSelected(ranking.index) === false ? 'plus-minus--more' : 'plus-minus--less' }}">
  </span>
</div>
</ng-template>
<ng-template app-row let-ranking>
<td colspan="100%" class="wa-table__cell wa-table__cell--fit">
  <div *ngIf="isIndexSelected(ranking.index) === true" class="wa-table-details" [@slideInOut]="animationState">
    <app-wa-table
    class="inner-table-open"
    [isSortableFunc]="sortClass" [showCondition]="true" [headers]="detailHeaders" [isDataLoading]="false"
    [areMoreData]="false" [data]="ranking.Details"
  >
    <ng-template app-column let-detail>
      <div class="img-inner" appCompetitionLink [isImage]="true" [size]="75" [competitionId]="detail.ID"></div>
    </ng-template>
    <ng-template app-column let-detail>
      <div>

      <a appCompetitionLink [competitionId]="detail.ID" class="uppertext-black-no-viewport"> {{detail.NameShort ? detail.NameShort : detail.Name}}</a>
    </div>
      <div class="uppertext-no-viewport">{{detail.Date | date : 'yyyy'}}</div>
    </ng-template>
    <ng-template app-column let-detail>
      <app-position-medals [Rnk]="detail.Position"></app-position-medals>
    </ng-template>
    <ng-template [extraClass]="['center-text']" app-column let-detail>
      <div class="uppertext-black-no-viewport"> {{detail.Points}}</div>
    </ng-template>
    <ng-template [extraClass]="['td-58']" app-column-responsive let-detail>

      <div>

        <a appCompetitionLink [competitionId]="detail.ID" class="uppertext-black-no-viewport"> {{detail.NameShort ? detail.NameShort : detail.Name}}</a>
      </div>
        <div class="uppertext-no-viewport">{{detail.Date | date : 'yyyy'}}</div>
    </ng-template>
    <ng-template [extraClass]="['td-20']" app-column-responsive let-detail>


        <app-position-medals [Rnk]="detail.Position" class="uppertext-no-viewport"></app-position-medals>


    </ng-template>
    <ng-template [extraClass]="['center-text']" app-column-responsive let-detail>
        <div class="uppertext-black-no-viewport nowrap">{{detail.Points}}</div>
    </ng-template>
  </app-wa-table>
  </div>
</td>
</ng-template>
<ng-template  app-column-responsive let-ranking>
  <div style="display: flex; justify-content: center; flex-direction: column;">

    <div class="border-ranking-box" >{{ ranking.Rnk }}</div>


    <div style="height: 10px;" *ngIf="ranking.Rnk === ranking.RnkOld;else variation" class="icon--equal"></div>
    <ng-template #variation>
      <div *ngIf="ranking.RnkOld && (ranking.Rnk < ranking.RnkOld)" class="icon--up">
        {{ {rank:ranking.Rnk, rankOld: ranking.RnkOld} | parseRank}}
        </div>
      <div *ngIf="ranking.RnkOld && (ranking.Rnk > ranking.RnkOld)" class="icon--down">
        {{ {rank:ranking.Rnk, rankOld: ranking.RnkOld} | parseRank}}
      </div>
      <ng-container *ngIf="ranking.Rnk && ranking.RnkOld == null">
        <div style="text-align: center; font-size: 12px;" class="list-row-item__ranking__arrow new new__margin">
          {{'NEW' | transloco}}
        </div>
      </ng-container>

    </ng-template>
  </div>
</ng-template>
<ng-template  [extraClass]="['wa-table__cell--fit']" app-column-responsive let-ranking>
<div class="inner-info">
  <lib-athlete-name [fname]="ranking.Athlete.FName" [gname]="ranking.Athlete.GName" [wnameord]="ranking.Athlete.WNameOrd" [id]="ranking.Athlete.Id"></lib-athlete-name>
  <div *ngIf="ranking.Team && ranking.Team.TeamName"><span class="uppertext-no-viewport">{{'Team' | transloco}}:          </span> {{ranking.Team.TeamName}}    </div>
  <div><span class="uppertext-black-no-viewport"></span>       <app-position-medals [Rnk]="ranking.Position" class="uppertext-no-viewport"></app-position-medals></div>
  <div><span class="uppertext-no-viewport">{{'Points' | transloco}}:          </span>  {{ranking.Points}}   </div>

</div>
</ng-template>
<ng-template app-column-responsive  let-ranking [extraClass]="['wa-table__cell--fit-right']">
<div class="list-row-item__action" *ngIf="{data:data, showDetails:false} as detail" (click)="selectIndex(ranking.index)">
  <span class="plus-minus {{isIndexSelected(ranking.index) === false ? 'plus-minus--more' : 'plus-minus--less' }}">
  </span>
</div>
</ng-template>
</app-wa-table>
